import React, { useState, useEffect, useCallback } from 'react';
import PageHeader from './components/PageHeader';
import DataTable from './components/DataTable';
import DashboardLoader from './components/DashboardLoader';
import { newsletterAPI } from '../../services/api';
import './ContentPage.css';

export default function NewsletterPage() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubscribers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await newsletterAPI.list();
      setSubscribers(res.data || []);
    } catch (err) {
      console.error('Failed to fetch subscribers:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchSubscribers(); }, [fetchSubscribers]);

  const activeCount = subscribers.filter((s) => s.is_active).length;

  const columns = [
    { key: 'email', label: 'Email', sortable: true },
    {
      key: 'created_at', label: 'Subscribed', sortable: true,
      render: (val) => val ? new Date(val).toLocaleDateString() : '—',
    },
    {
      key: 'is_active', label: 'Status', sortable: true,
      render: (val) => (
        <span style={{
          fontSize: '0.75rem',
          fontWeight: 600,
          padding: '0.2rem 0.6rem',
          borderRadius: '20px',
          background: val ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
          color: val ? '#10b981' : '#ef4444',
        }}>
          {val ? 'Active' : 'Inactive'}
        </span>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="Newsletter"
        subtitle={`${subscribers.length} subscribers · ${activeCount} active`}
        backTo="/dashboard"
        icon={
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        }
      />

      {loading ? (
        <DashboardLoader text="Loading subscribers..." />
      ) : (
        <DataTable
          columns={columns}
          data={subscribers}
          searchPlaceholder="Search subscribers..."
          emptyMessage="No newsletter subscribers yet"
        />
      )}
    </div>
  );
}
